import api from './api';

/**
 * Service for notification-related API calls
 * All methods return { success: true, data } or { success: false, error }
 */

const notificationService = {
  /**
   * Fetch user's notifications (paginated)
   * @param {Object} params - Query parameters (is_read, notification_type, page)
   */
  async fetchNotifications(params = {}) {
    try {
      const response = await api.get('/notifications/', { params });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching notifications:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch notifications'
      };
    }
  },

  /**
   * Fetch unread notification count
   */
  async fetchUnreadCount() {
    try {
      const response = await api.get('/notifications/unread-count/');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching unread count:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch unread count'
      };
    }
  },

  /**
   * Mark a notification as read
   * @param {number} notificationId
   */
  async markAsRead(notificationId) {
    try {
      const response = await api.post(`/notifications/${notificationId}/read/`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error marking notification as read:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to mark as read'
      };
    }
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead() {
    try {
      const response = await api.post('/notifications/read-all/');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error marking all as read:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to mark all as read'
      };
    }
  },

  /**
   * Delete a notification
   * @param {number} notificationId
   */
  async deleteNotification(notificationId) {
    try {
      await api.delete(`/notifications/${notificationId}/`);
      return { success: true };
    } catch (error) {
      console.error('Error deleting notification:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to delete notification'
      };
    }
  },

  /**
   * Fetch notification preferences
   */
  async fetchPreferences() {
    try {
      const response = await api.get('/notifications/preferences/');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching preferences:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch preferences'
      };
    }
  },

  /**
   * Update notification preferences
   * @param {Object} preferences
   */
  async updatePreferences(preferences) {
    try {
      const response = await api.put('/notifications/preferences/', preferences);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating preferences:', error);
      return {
        success: false,
        error: error.response?.data || 'Failed to update preferences'
      };
    }
  }
};

export default notificationService;
